import { render, staticRenderFns } from "./bo-datatable-new.vue?vue&type=template&id=30b6bb7e"
import script from "./bo-datatable-new.vue?vue&type=script&lang=js"
export * from "./bo-datatable-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports